// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AuthenticationType } from './AuthenticationType';
import { VelocityAuthenticationService } from './Velocity/VelocityAuthenticationService';
import { CapitalFuturesAuthenticationService } from './CapitalFutures/CapitalFuturesAuthenticationService';
class _AuthenticationFactory {
    create(params) {
        switch (params.type) {
            case AuthenticationType.Velocity:
                return new VelocityAuthenticationService(params.url, params.logoutUrl, params.clientId);
            case AuthenticationType.CapitalFutures:
                return new CapitalFuturesAuthenticationService(params.url, params.customUrl);
            default:
                return undefined;
        }
    }
}
export const AuthenticationFactory = new _AuthenticationFactory();
